import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { FormField } from '../../../forms/formField/index';
import { normalizePostcode } from '../../../helpers/normalizers';
import styles from '../LinkDebitCard.module.css';

export function BillingPostcodeQuestion() {
    return (
        <div className={styles.field}>
            <FormField
                label={
                    <FormattedMessage
                        id="_.link_debit_card.billing_postcode"
                        defaultMessage="Billing postcode"
                    />
                }
                className={classNames(styles.billingPostcode, 'fs-exclude')}
                name="billingPostcode"
                normalize={normalizePostcode}
                placeholder="e.g. N6 6NG"
            />
        </div>
    );
}
